import { FC, useState } from 'react';
import { clsx } from 'clsx';
import { ColorsTab } from 'widgets/choose-background/ui/ColorsTab';
import { TTheme } from 'widgets/choose-background/ui/types';
import { MediaTab } from './MediaTab';
import { UploadTab } from './UploadTab';

const tabs = ['Colors', 'Image / Video', 'Upload'];

interface IProps {
  selectedBackground: string;
  onChange: (background: string | null) => void;
  customImageBackgrounds: string[];
  customVideoBackgrounds: string[];
  setCustomImageBackgrounds: (backgrounds: string[]) => void;
  setCustomVideoBackgrounds: (backgrounds: string[]) => void;
  theme?: TTheme;
}

export const ChooseBackground: FC<IProps> = ({
  selectedBackground,
  onChange,
  customVideoBackgrounds,
  customImageBackgrounds,
  setCustomImageBackgrounds,
  setCustomVideoBackgrounds,
  theme = 'dark'
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [customColor, setCustomColor] = useState<string | null>('');

  return (
    <div className="ag-h-full lg:ag-min-h-96">
      <div className="ag-flex ag-flex-row ag-justify-center ag-h-[54px] ag-gap-2 ag-items-center ag-bg-white ag-rounded-[15px] ag-border ag-overflow-hidden ag-mx-auto ag-w-full ag-mb-6">
        {tabs.map((tab, index) => (
          <div
            key={tab}
            className={clsx(
              'ag-py-[10px] ag-select-none hover:ag-bg-purple-50 hover:ag-text-purple-600 ag-rounded-[10px] ag-h-[38px] ag-flex ag-flex-col ag-justify-center ag-items-center ag-px-4 ag-text-sm ag-font-medium ag-cursor-pointer ag-transition-all',
              currentTab === index
                ? 'ag-bg-purple-50 ag-text-purple-600'
                : 'ag-text-neutral-600'
            )}
            onClick={() => setCurrentTab(index)}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="ag-max-h-[calc(100%-100px)] lg:ag-h-full ag-overflow-auto ag-relative">
        {currentTab === 0 && (
          <ColorsTab
            selectedBackground={selectedBackground}
            theme={theme}
            customColor={customColor}
            onChange={onChange}
            setCustomColor={setCustomColor}
          />
        )}
        {currentTab === 1 && (
          <MediaTab
            theme={theme}
            onChange={onChange}
            customImageBackgrounds={customImageBackgrounds}
            setCustomImageBackgrounds={setCustomImageBackgrounds}
            selectedBackground={selectedBackground}
            setCustomVideoBackgrounds={setCustomVideoBackgrounds}
            customVideoBackgrounds={customVideoBackgrounds}
          />
        )}
        {currentTab === 2 && (
          <UploadTab
            theme={theme}
            onChange={onChange}
            customImageBackgrounds={customImageBackgrounds}
            setCustomImageBackgrounds={setCustomImageBackgrounds}
            selectedBackground={selectedBackground}
            setCustomVideoBackgrounds={setCustomVideoBackgrounds}
            customVideoBackgrounds={customVideoBackgrounds}
          />
        )}
      </div>
    </div>
  );
};
